import { Team, TeamCreate, TeamUpdate } from "@/types/team";

import { requestData } from "@/api/api-config";

export async function fetchTeams(): Promise<Team[] | null> {
  return await requestData<Team[]>("team", "get");
}

export async function createTeam(data: TeamCreate): Promise<Team | null> {
  return await requestData<Team>("team", "post", { json: data }, false);
}

export async function updateTeam(
  teamId: string,
  data: TeamUpdate,
): Promise<Team | null> {
  return await requestData<Team>(
    `team/${teamId}`,
    "put",
    { json: data },
    false,
  );
}

export async function deleteTeam(teamId: string): Promise<void> {
  await requestData(`team/${teamId}`, "delete", undefined, false);
}
